import React, { FunctionComponent } from "react";
import { NotFoundPage } from "./component";

export const NotFoundPageContainer: FunctionComponent = () => {
  return <NotFoundPage />;
};
